import { generateMesageObservable, getDataLoader } from './dataLoader';
import { writable } from 'svelte/store';
import { UserCredential } from './store';
import { USER_ROLE } from './common';
export const newSensorTempretureObservable = writable(null);
function lisenForTempretures() {
    const socketObs = generateMesageObservable('/ws/newTemperatures');
    // POTENTIONAL MEM LEAK - TODD
    socketObs.subscribe((msg) => {
        if (msg) {
            console.log("[INFO; probe temp]:", msg);
            try {
                const parsedMsg = JSON.parse(msg);
                newSensorTempretureObservable.set(parsedMsg);
            }
            catch (err) {
                console.warn('Cannot parse msg from newTemperatures');
            }
        }
    });
}
export const newSensorConectionObservable = writable(null);
function lisenForNewSensorConection() {
    const socketObs = generateMesageObservable('/ws/newID');
    // POTENTIONAL MEM LEAK - TODD
    socketObs.subscribe((msg) => {
        if (msg) {
            console.log("[INFO; probe id]:", msg);
            try {
                const parsedMsg = JSON.parse(msg);
                newSensorConectionObservable.set(parsedMsg);
                newSensorConectionObservable.set(null); //TODO
            }
            catch (err) {
                console.warn('Cannot parse msg from newTemperatures');
            }
        }
    });
}
export async function getConnectedProbe() {
    const data = await getDataLoader().postJson('/getSensorInfo', {});
    console.log(data);
    return data;
}
export async function getDocCode(mesurment) {
    const data = await getDataLoader().postJson('/sent/kl', mesurment);
    console.log(data);
    return data;
}
export async function loginUser(userName, password) {
    const response = await getDataLoader().getToken(userName, password);
    if (!response.success) {
        return false;
    }
    UserCredential.connect({
        userName: userName,
        id: response.json.userInformation.id,
        role: response.json.userInformation.role,
        roleInfo: response.json.userInformation.role === USER_ROLE.DEV.id
            ? USER_ROLE.DEV
            : response.json.userInformation.role ===
                USER_ROLE.TECHNICIAN.id
                ? USER_ROLE.TECHNICIAN
                : response.json.userInformation.role ===
                    USER_ROLE.ASISTENT.id
                    ? USER_ROLE.ASISTENT
                    : response.json.userInformation.role === USER_ROLE.MANAGER.id
                        ? USER_ROLE.MANAGER
                        : USER_ROLE.DEV,
    }, response.json.jwt);
    return true;
}
// INIT EXE
lisenForTempretures();
lisenForNewSensorConection();
